import { type RouteRecordRaw } from 'vue-router'
export const staffRouter: RouteRecordRaw[] = [
  {
    async beforeEnter() {
      // Enable MSW mocking for staff routes in development mode
      if (
        import.meta.env.MODE === 'development' &&
        import.meta.env.VITE_ENABLE_MOCKS === 'true'
      ) {
        const { startMockWorker, isMockWorkerStarted } = await import(
          '@/mocks/browser'
        )
        if (!isMockWorkerStarted()) {
          await startMockWorker()
        }
      }
    },

    children: [
      {
        component: async () => import('../views/BrandStaffMembersView.vue'),
        meta: {
          permissions: [{ operation: 'read', resource: 'user.staff' }],
          scopes: ['users:staff:read'],
          title: 'staff-members',
        },
        name: 'brand.staff.members',
        path: 'members',
      },
      {
        component: async () => import('../views/BrandStaffJobsView.vue'),
        meta: {
          permissions: [{ operation: 'read', resource: 'employment.jobs' }],
          scopes: ['employment:jobs:read'],
          title: 'staff-jobs',
        },
        name: 'brand.staff.jobs',
        path: 'jobs',
      },
      {
        component: async () => import('../views/StaffTimesheetsView.vue'),
        meta: {
          scopes: ['employment:shifts:read'],
          title: 'staff-timesheets',
        },
        name: 'brand.staff.timesheets',
        path: 'timesheets',
      },
    ],
    path: 'staff',
  },
]
